const { Component } = require('react')

class Widget extends Component {
  get title () {
    return 'Widget'
  }

  get description () {
    // ...
  }

  get className () {
    return 'widget'
  }

  renderBody () {
    // ...
  }

  renderFooter () {
    // ...
  }

  render () {
    return (
      <div className={this.className}>
        <div className='widget-header'>
          {this.title}
          {this.description}
        </div>
        <div className='widget-body'>{this.renderBody()}</div>
        <div className='widget-footer'>{this.renderFooter()}</div>
      </div>
    )
  }
}

module.exports = Widget
